var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadgeFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9193 5.69418C14.5797 6.24448 15 7.07316 15 8C15 8.92684 14.5797 9.75552 13.9193 10.3058C13.9721 10.5286 14 10.7611 14 11C14 12.6569 12.6569 14 11 14C10.7611 14 10.5286 13.9721 10.3058 13.9193C9.75552 14.5797 8.92684 15 8 15C7.07316 15 6.24448 14.5797 5.69418 13.9193C5.47137 13.9721 5.23895 14 5 14C3.34315 14 2 12.6569 2 11C2 10.7611 2.02794 10.5286 2.08072 10.3058C1.42031 9.75552 1 8.92684 1 8C1 7.07316 1.42031 6.24448 2.08072 5.69418C2.02794 5.47137 2 5.23895 2 5C2 3.34315 3.34315 2 5 2C5.23895 2 5.47137 2.02794 5.69418 2.08072C6.24448 1.42031 7.07316 1 8 1C8.92684 1 9.75552 1.42031 10.3058 2.08072C10.5286 2.02794 10.7611 2 11 2C12.6569 2 14 3.34315 14 5C14 5.23895 13.9721 5.47137 13.9193 5.69418ZM9.71967 10.7803C10.0126 11.0732 10.4874 11.0732 10.7803 10.7803C11.0732 10.4874 11.0732 10.0126 10.7803 9.71967L9.06066 8L10.7803 6.28033C11.0732 5.98744 11.0732 5.51256 10.7803 5.21967C10.4874 4.92678 10.0126 4.92678 9.71967 5.21967L8 6.93934L6.28033 5.21967C5.98744 4.92678 5.51256 4.92678 5.21967 5.21967C4.92678 5.51256 4.92678 5.98744 5.21967 6.28033L6.93934 8L5.21967 9.71967C4.92678 10.0126 4.92678 10.4874 5.21967 10.7803C5.51256 11.0732 5.98744 11.0732 6.28033 10.7803L8 9.06066L9.71967 10.7803Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeFail);
export default __webpack_public_path__ + "static/media/badge_fail.ff0525efde908d24b122d6923a471f29.svg";
export { ForwardRef as ReactComponent };